<template>
	<Button
		icon
		@click="onClick"
		type="light"
		:size="size"
		:disabled="disabled"
		v-tooltip="'Imprimir'"
	>
		<template #icon>
			<IconPrint :size="size" />
		</template>
	</Button>
</template>

<script>
import Button from './Button.vue'
import IconPrint from '../icon/IconPrint.vue'
import ButtonMixin from './ButtonMixin.js'
export default {
	mixins: [ButtonMixin],
	components: {
		Button,
		IconPrint
	}
}
</script>
